import Formatter from "@rmlibrary/formatting";
import { saveToStorage } from "../utilities";

const formatter = new Formatter();

function storePrintValues({
    annualPercentageIncrease,
    biWeeklyContributions,
    contributionAmount,
    monthlyContributions,
    name,
    startingAmount
}) {
    contributionAmount = formatter.parseNumber(contributionAmount);
    startingAmount = formatter.parseNumber(startingAmount);
    const biWeeklyContributionAmount = contributionAmount / 2;

    const value = {
        annualPercentageIncrease,
        biWeeklyContributions,
        contributionAmounts: {
            biWeekly: biWeeklyContributionAmount,
            monthly: contributionAmount
        },
        monthlyContributions,
        name,
        startingAmount
    };

    saveToStorage("pacvideo", value);
}

export { storePrintValues };
